"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _overrides = require("../helpers/overrides");
var _styledComponents = require("./styled-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function ListItemLabel(props) {
  const {
    overrides = {}
  } = props;
  const [LabelSublistContent, labelSublistContentProps] = (0, _overrides.getOverrides)(overrides.LabelSublistContent, _styledComponents.StyledLabelSublistContent);
  const [LabelRoot, labelRootProps] = (0, _overrides.getOverrides)(overrides.LabelRoot, _styledComponents.StyledLabelRoot);
  const [LabelContent, labelContentProps] = (0, _overrides.getOverrides)(overrides.LabelContent, _styledComponents.StyledLabelContent);
  const [LabelDescription, labelDescriptionProps] = (0, _overrides.getOverrides)(overrides.LabelDescription, _styledComponents.StyledLabelDescription);
  if (props.sublist) {
    return /*#__PURE__*/_react.default.createElement(LabelSublistContent, labelSublistContentProps, props.children);
  }
  return /*#__PURE__*/_react.default.createElement(LabelRoot, labelRootProps, /*#__PURE__*/_react.default.createElement(LabelContent, labelContentProps, props.children), props.description && /*#__PURE__*/_react.default.createElement(LabelDescription, labelDescriptionProps, props.description));
}
var _default = exports.default = ListItemLabel;